import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { faChampagneGlasses } from "@fortawesome/free-solid-svg-icons";

// Create slice
const name = "draft";

const initialState = createInitialState();
const extraActions = createExtraActions();

// Create the slice
const slice = createSlice({
  name,
  initialState,
  reducers: {
    setTotalMessages: (state, action) => {
      state.totalMessages = action.payload;
    },
    incrementPage: (state) => {
      state.currentPage += 1;
    },
  },
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// Exports
export const DraftMessagesActions = { ...slice.actions, ...extraActions };
export const draftMessagesReducer = slice.reducer;

// Initial state function
function createInitialState() {
  return {
    DraftMessagesList: [],
    loading: false,
    error: null,
    currentPage: 1,
    totalMessages: 0,
  };
}

// Function to create extra actions
function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/PublicUser/Draft`;
  const errorLogURL = `${process.env.REACT_APP_API_URL}`;

  return {
    LoadDraftMessages: loadDraftMessages(),
    DiscardDraftMessages: discardDraftMessages(),
    SaveTextFile: saveTextFile(),
    CreateEventLogTextFileForInbox: CreateEventLogTextFileForInbox(),
  };

  function loadDraftMessages() {
    return createAsyncThunk(
      `${name}/GetDraftMessages`,
      async (
        { userID, pageNo, rowCountPerPage, sortField },
        { rejectWithValue }
      ) => {
        try {
          const params = { userID, pageNo, rowCountPerPage, sortField };
          const response = await fetchWrapper.post(
            `${baseUrl}/LoadDraftMessages`,
            params
          );
          return response;
        } catch (error) {
          return rejectWithValue(error.message);
        }
      }
    );
  }

  function discardDraftMessages() {
    return createAsyncThunk(
      `${name}/DiscardDraftMessage`,
      async (DraftID, { rejectWithValue }) => {
        try {
          const response = await fetchWrapper.post(
            `${baseUrl}/DiscardDraftMessage?DraftID=${DraftID}`
          );
          return response;
        } catch (error) {
          return rejectWithValue(error.message);
        }
      }
    );
  }
  function saveTextFile() {
    return createAsyncThunk(
      `${name}/CreateTextFile`,
      async (data) =>
        await fetchWrapper.post(
          `${errorLogURL}/ErrorLog/CreateTextFile`,
          data,
          true
        )
    );
  }

  // event log for inbox
  function CreateEventLogTextFileForInbox() {
    return createAsyncThunk(
      `${name}/CreateEventLogTextFileForInbox`,
      async (data) =>
        await fetchWrapper.post(
          `${errorLogURL}/ErrorLog/CreateEventLogTextFileForInbox`,
          data,
          true
        )
    );
  }
  // function saveTextFile() {
  //   return createAsyncThunk(
  //     `${name}/CreateTextFile`,
  //     async (DataInput, { rejectWithValue }) => {
  //       try {
  //         const response = await fetchWrapper.post(`${baseUrl1}/ErrorLog/CreateTextFile?=${DataInput}`);
  //         return response;
  //       } catch (error) {
  //         return rejectWithValue(error.message);
  //       }
  //     }
  //   );
  // }
}

// Adding the extra reducers for the async actions
function createExtraReducers(builder) {
  builder
    .addCase(DraftMessagesActions.LoadDraftMessages.pending, (state) => {
      state.LoadDraftMessages = true;
      state.loading = true;
    })
    .addCase(
      DraftMessagesActions.LoadDraftMessages.fulfilled,
      (state, action) => {
        state.loading = false;
        if (action.meta.arg.append) {
          // Append new data to the existing list
          state.DraftMessagesList = [
            ...state.DraftMessagesList,
            ...(action.payload || []),
          ];
        } else {
          state.DraftMessagesList = action.payload || [];
        }
        state.LoadDraftMessages = false;
      }
    )
    .addCase(
      DraftMessagesActions.LoadDraftMessages.rejected,
      (state, action) => {
        state.LoadDraftMessages = false;
        state.loading = false;
        state.error = action.payload;
      }
    )

    .addCase(DraftMessagesActions.DiscardDraftMessages.pending, (state) => {
      state.DiscardDraftMessages = true;
    })
    .addCase(
      DraftMessagesActions.DiscardDraftMessages.fulfilled,
      (state, action) => {
        state.DiscardDraftMessages = action.payload;
        state.loading = false;
      }
    )
    .addCase(
      DraftMessagesActions.DiscardDraftMessages.rejected,
      (state, action) => {
        state.DiscardDraftMessages = false;
        state.error = action.payload;
      }
    )

    // event log for inbox
    .addCase(
      DraftMessagesActions.CreateEventLogTextFileForInbox.pending,
      (state) => {
        state.DiscardDraftMessages = true;
      }
    )
    .addCase(
      DraftMessagesActions.CreateEventLogTextFileForInbox.fulfilled,
      (state, action) => {
        state.CreateEventLogTextFileForInboxResponse = action.payload;
        state.loading = false;
      }
    )
    .addCase(
      DraftMessagesActions.CreateEventLogTextFileForInbox.rejected,
      (state, action) => {
        state.DiscardDraftMessages = false;
        state.error = action.payload;
      }
    );
}
